import { render } from "./add-new-doctor.vue?vue&type=template&id=a843428c&scoped=true"
import script from "./add-new-doctor.vue?vue&type=script&lang=js"
export * from "./add-new-doctor.vue?vue&type=script&lang=js"

import "./add-new-doctor.vue?vue&type=style&index=0&id=a843428c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a843428c"]])

export default __exports__